import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '../../../fragments/dialog';
import {FormInline} from '../../../fragments/forms';


export default class ChooseSeqtypeDialog extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  handleChooseRadio(e) {
    e && e.preventDefault();
    let {rawDataCollection} = this.props;

    if (rawDataCollection.sequenceType === 'complete') {
      rawDataCollection.rawSequences = [];
      rawDataCollection.rawAlignments = [];
    }

    rawDataCollection.sequenceType = 'incomplete';
    rawDataCollection.seqType = e.target.value;

    const {onUpdate} = this.props;
    onUpdate(rawDataCollection);
  }

  closeDialog() {
    const {onClose} = this.props;
    onClose();
  }

  render() {

    return (
      <Dialog
       onClose={this.closeDialog.bind(this)}
       width="42rem"
       closeOnBlur={false}>
        <h3>Mutation List</h3>
        <p>Please choose type of virus samples.</p>
        <FormInline dom="div">
          <input type="radio" name="seqtype1" value="ClinicalList"
           onClick={this.handleChooseRadio.bind(this)}
          />
          <label htmlFor="seqtype1">Clinical</label>
          <br/>
          <input type="radio" name="seqtype2" value="LabList"
           onClick={this.handleChooseRadio.bind(this)}
          />
          <label htmlFor="seqtype2">Lab</label>
          <br/>
        </FormInline>
      </Dialog>

    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/upload/choose-seqtype.js